<template>
  <div class="formula-capture-wrapper">
    <el-input
      :value="displayValue"
      disabled
      type="text"
      class="shadow-sm formula-result-input"
    />
    <span class="formula-badge">
      <i class="fa fa-calculator"></i> Auto
    </span>
  </div>
</template>

<script>
import mixinVModel from 'src/util/mixinVModel';

export default {
  name: 'FormulaCapture',

  mixins: [mixinVModel],

  props: {
    value: {
      default: null,
    },
    formulaExpression: {
      type: String,
      default: '',
    },
  },

  computed: {
    displayValue() {
      const v = this.localValue;
      if (v === null || v === undefined || v === '') return '—';
      const num = parseFloat(v);
      if (!isNaN(num)) {
        // Show up to 2 decimal places but strip trailing zeros
        return parseFloat(num.toFixed(2)).toString();
      }
      return String(v);
    },
  },

  methods: {
    /**
     * Required by CaptureConfirm's validation loop.
     * Formula fields are always valid (read-only, auto-computed).
     */
    validate() {
      return true;
    },
  },
};
</script>

<style scoped>
.formula-capture-wrapper {
  position: relative;
  display: inline-block;
  width: 100%;
}

.formula-result-input :deep(.el-input__inner) {
  background-color: #f0f6ea !important;
  color: #4a6b1f !important;
  font-weight: 700 !important;
  border: 1.5px solid #8bb352 !important;
  text-align: center;
  cursor: default;
}

.formula-badge {
  position: absolute;
  top: -8px;
  right: 4px;
  font-size: 10px;
  background: #8bb352;
  color: #fff;
  border-radius: 4px;
  padding: 1px 5px;
  pointer-events: none;
  white-space: nowrap;
}
</style>
